import React, { useState , useEffect } from 'react';
import banImg from "../../assets/images/career/form-banner.webp";
import file from "../../assets/images/career/file-upload.svg";
import "./apply-form.scss";
import { useForm } from 'react-hook-form';
import meta_tags from '../../Data/MetaTags';
import {
  useLocation,
} from 'react-router-dom';
import FormService from "../API-Services/FormService";
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode } from "react-phone-number-input";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
function ApplyForm() {
  const [showError, setShowError] = useState(false);
  const [numberLen, setNumberLen] = useState(25);
  const [countryCode, setCountryCode] = useState("91");
  const [mobileNum, setmobileNum] = useState("");
  const [num_error, setNum_error] = useState("");
  const [loading, setLoading] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [fileName, setFileName] = useState('');
  const [resumeFile, setResumeFile] = useState(null);
  const [locations, setLocations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [positions, setPositions] = useState([]);
  const [checkErrors, setCheckErrors] = useState(false);
  const [fileError, setFileError] = useState('');
  const { register, handleSubmit, reset, formState: { errors },clearErrors  } = useForm({ mode: "onChange" });
  const [rendercount, setRenderCount] = useState(() => false);
  const location = useLocation();

  function scrollErrorField() {
    //scroll up if there is any error
    if (Object.keys(errors).length > 0 && checkErrors) {
      const firstErrorField = Object.keys(errors)[0];
      // Get the corresponding input element
      const errorFieldElement = document.querySelector(
        `[name=${firstErrorField}]`
      );
      // Scroll to the error field if it exists
      if (errorFieldElement) {
        errorFieldElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }
  }
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validExtensions = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (validExtensions.includes(file.type)) {
        setFileName(file.name);
        setResumeFile(file);
        setFileError('');
        clearErrors('resume');
      } else {
        setFileName('');
        setResumeFile(null);
        setFileError('Only .pdf, .doc, and .docx files are allowed.');
      }
    } else {
      setFileName('');
      setResumeFile(null);
      setFileError('');
    }
  };
  const loadLocations = async () => {
    try {
      const response = await FormService.Getldpform({ request_type: "locations", request_id: "" });
      if (response.data && Array.isArray(response.data.body)) {
        setLocations(response.data.body);
      } else {
        console.error("Unexpected API response structure", response.data);
        toast.error("Failed to load locations.");
      }
    } catch (error) {
      console.error("Failed to load locations: ", error);
      toast.error("Failed to load locations.");
    }
  };

  const loadDepartments = async (locationId) => {
    try {
      const response = await FormService.Getldpform({ request_type: "departments", request_id: locationId });
      
      if (Array.isArray(response.data.body)) {
        setDepartments(response.data.body);
        setPositions([]); // Clear positions when location changes
      } else {
        console.error("Departments API did not return an array", response.data);
        toast.error("Failed to load departments.");
      }
    } catch (error) {
      console.error("Failed to load departments: ", error);
      toast.error("Failed to load departments.");
    }
  };

  const loadPositions = async (departmentId) => {
    try {
      const response = await FormService.Getldpform({ request_type: "positions", request_id: departmentId });
      
      if (Array.isArray(response.data.body)) {
        setPositions(response.data.body);
        clearErrors("position_id")
      } else {
        console.error("Positions API did not return an array", response.data.body);
        toast.error("Failed to load positions.");
      }
    } catch (error) {
      console.error("Failed to load positions: ", error);
      toast.error("Failed to load positions.");
    }
  };

  const mobileHandler = (e) => {
    if (e === undefined) {
      return;
    }
    const newValue = e.replace(/\s/g, '');
    setmobileNum(newValue);
    if (newValue === undefined || newValue.length === 0) {
      setNum_error("Mobile Number is required");
      setShowError(true);
      return;
    }
    if (countryCode === "91") {
      setNumberLen(15);
    } else {
      setNumberLen(25);
    }
    if (!isValidPhoneNumber(newValue.toString())) {
      setNum_error("Please enter a valid number");
      setShowError(true);
      return;
    } else {
      setNum_error("");
      setShowError(false);
    }
  };

  const formHandler = (data) => {
    if (mobileNum.length <= 3) {
      setShowError(true);
      setNum_error("Mobile Number is required");
      return;
    }

    setShowError(false);
    setLoading(true);

    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('email', data.email);
    formData.append('location_id', data.location_id);
    formData.append('department_id', data.department_id);
    formData.append('position_id', data.position_id);
    formData.append('comment', data.comment || '');
    formData.append('mobile_number', mobileNum.substring(mobileNum.indexOf(countryCode) + countryCode.length));
    formData.append('country_code', countryCode);
    formData.append('resume', resumeFile);

    FormService.getCareerForm(formData).then((res) => {
      setLoading(false);
      setCountryCode("91");
      reset();
      setmobileNum("");
      setFileName('')
      setShowToaster(true);
    }).catch((err) => {
      setLoading(false);
      if (err && err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Something went wrong, please try again later!");
      }
    });
  };

  const handleLocationChange = (e) => {
    const locationId = e.target.value;
    clearErrors("location_id")
    loadDepartments(locationId);
  };

  const handleDepartmentChange = (e) => {
    const departmentId = e.target.value;
    clearErrors("department_id")
    loadPositions(departmentId);
  };

  const handleLocationClick = () => {
    if (locations.length === 0) {
      loadLocations();
    }
  };
  useEffect(() => {
    if (showToaster) {
      const timer = setTimeout(() => {
        setShowToaster(false);
      }, 10000); // Hide toaster after 10 seconds

      return () => clearTimeout(timer);
    }
  }, [showToaster]);


  useEffect(() => {
    setRenderCount(true)
    if (rendercount === true) {
      document.title = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].title : '';
      document.getElementById('meta-tags').content = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].content : '';
      document.getElementById('canonical-link').href = meta_tags[location.pathname.replace('/', "")] ? meta_tags[location.pathname.replace('/', "")].link : '';  
      if(!(document.getElementById('link1')==null)){
        document.getElementById('link1').remove();
        document.getElementById('link2').remove();
        document.getElementById('link3').remove();
        document.getElementById('link4').remove();
        document.getElementById('link5').remove();
        document.getElementById('link6').remove();
      }
    }
  }, [rendercount])

  return (
    <>
    <div className={`toaster toaster-top ${showToaster ? 'toaster-active' : ''}`}>
        <div className='close-tst' onClick={() => setShowToaster(false)}>
          <FontAwesomeIcon icon={faClose} />
        </div>
        <h3 className='tst-heading'>Thank you for your application!</h3>
        <p className='fnt-11'>Your application has been successfully submitted. Our HR team will be in touch with you soon.</p>
      </div>
      <section className='banner-apply'>
        <img src={banImg} className="ban-img" />
        <div className='banner-caption-sec'>
          <div className='container'>
            <div className='form-caption'>
              <div className='left-sec'>
                <div className='caption-banner'>
                  <div className='ban-caption'>
                    <h1 className='big-ttl'>Join Our Team</h1>
                    <p className='sm-para'>Are you ready to shape the future of fintech? Join us at Choice Techlab, where innovation meets impact. We’re developing cutting-edge IT products that revolutionize finance. Be part of our dynamic team, embrace new challenges, and grow with us. Apply now and let's create the future together!</p>
                  </div>
                </div>
              </div>
              <div className='right-sec'>
                <div className='clt-form'>
                  <h3>Application Form</h3>
                  <form onSubmit={handleSubmit(formHandler)}>
                    <div className='form-wrapper form-apply'>
                      <div className="form-control">
                        <input
                          type="text"
                          name="name"
                          placeholder='Full Name' className='form-field'
                          maxLength={120}
                          autoComplete='off'
                          {...register("name", {
                            required: true,
                            pattern: /^[a-zA-z]+([\s][a-zA-Z]+)*$/
                          })}
                          onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z ]/gi, "")}
                        />
                        {errors.name?.type === "required" ? <span className="text-danger">Name is required </span> :
                          errors.name?.type === "pattern" ? <span className="text-danger">Please provide valid name</span> : ""}
                      </div>
                      <div className="form-control">
                        <input
                          type="text"
                          name="email"
                          placeholder='Email Address' className='form-field'
                          autoComplete='off'
                          {...register("email", {
                            required: true,
                            pattern: /^[a-zA-Z]{1}[A-Za-z0-9._%+-]{1,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/
                          })}
                        />
                        {errors.email?.type === "pattern" ? <span className="text-danger">Please enter valid email ID </span> :
                          errors.email?.type === "required" ? <span className="text-danger">Email is required</span> : ""}
                      </div>
                      <div className="form-control">
                                <div
                                  className=""
                                  onValuesChange={(val, all) => console.log(val, all)}
                                >
                                  <div name="phone" label="aa">
                                    <PhoneInput
                                      placeholder="Enter phone number"
                                      value={mobileNum}
                                      name="phone_number"
                                      autoComplete="off"
                                      onChange={(e) => {
                                        mobileHandler(e);
                                      }}
                                      onCountryChange={(v) =>
                                        setCountryCode(getCountryCallingCode(v))
                                      }
                                      maxLength={numberLen}
                                      defaultCountry="IN"
                                      international
                                      countryCallingCodeEditable={false}
                                    />
                                  </div>
                                </div>
                                {showError && (
                                  <span className="text-danger">{num_error}</span>
                                )}
                              </div>
                      <div className="form-control">
                        <select className='form-field' name="location"
                          {...register("location_id", { required: true })}
                          onChange={handleLocationChange}
                          onClick={handleLocationClick}
                          defaultValue={""}
                        >
                          <option value={""} disabled>Location</option>
                          {locations.map((location) => (
                            <option key={location.key_id} value={location.key_id}>{location.key_text}</option>
                          ))}
                        </select>
                        {errors.location_id?.type === "required" && <span className="text-danger">Location is required </span>}
                      </div>
                      <div className="form-control">
                        <select className='form-field' name="department"
                          {...register("department_id", { required: true })}
                          onChange={handleDepartmentChange}
                          defaultValue={""}
                        >
                          <option value={""}  disabled>Department</option>
                          {departments.length === 0 ?
                            <option value={""} disabled>Select Location First</option>
                            :
                            departments.map((department) => (
                              <option key={department.key_id} value={department.key_id}>{department.key_text}</option>
                            ))
                          }
                        </select>
                        {errors.department_id?.type === "required" && <span className="text-danger">Department is required </span>}
                      </div>
                      <div className="form-control">
                        <select className='form-field' name="position"
                          {...register("position_id", { required: true })}
                          defaultValue={""}
                        >
                          <option value={""} disabled>Position</option>
                          {positions.length === 0 ?
                            <option value={""} disabled className='slct-first'>Select Department First</option>
                            :
                            positions.map((position) => (
                              <option key={position.key_id} value={position.key_id}>{position.key_text}</option>
                            ))
                          }
                        </select>
                        {errors.position_id?.type === "required" && <span className="text-danger">Position is required </span>}
                      </div>
                      <div className="form-control">
                        <label className='file-label'>Upload Resume {fileError && <span className="text-danger">{fileError}</span>}</label>
                        <div className='file-upload-container'>
                          <div className="custom-file-input" name="upload_resume"
                            {...register("resume", { required: true })}
                          >
                            <input
                              type="file"
                              id="file-input"
                              className="file-upload"
                              onChange={handleFileChange}
                              accept=".pdf,.doc,.docx"
                            />
                            <label htmlFor="file-input" className="custom-file-label">
                              <img src={file} className='img-upload' />
                              {fileName || 'Drop your File Here or Browse'}
                            </label>
                          </div>
                        </div>
                        {errors.resume?.type === "required" && <span className="text-danger">Resume is required </span>}
                        
                      </div>
                      <div className="form-control">
                        <textarea rows="3" className="form-field" placeholder="Cover / Comment (upto 500 words)" name="comments"
                          autoComplete='off'  {...register("comment")} />
                      </div>
                      <div className="form-control">
                      <button
                      type="submit"
                      className="btn submt-btn"
                      onClick={() => {
                        setCheckErrors(true);
                        scrollErrorField();
                        if (mobileNum.length <= 3) {
                          setNum_error("Mobile Number is required");
                          setShowError(true);
                        }
                      }}
                    >
                      {loading ? (
                        <div className="loaderB mx-auto"></div>
                      ) : (
                        "Submit"
                      )}
                    </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section-empty"></section>
    </>
  );
}

export default ApplyForm;
